import { Member } from "./Member";

export class MemberProfileCreate extends Member {
  MemberCategoryId: number;
  groups: number;
  sendJoiningEmail: boolean;

}
